import Button from "./Button";
import React from "react";
import classNames from 'classnames';
import {paramsSerializer, UrlGenerator} from "../../utils/request";
import isEqual from "lodash-es/isEqual";
import {getComponentConfig} from "../../utils/components";

export default class PrintButton extends React.Component {

    state = {
        componentConfig: null
    }

    constructor(props) {
        super(props);
        this.loadComponentConfig();
    }

    componentDidMount() {
        this.loadComponentConfig();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((this.props.component_type || (this.props.componentConfig || {}).componentname) !== (prevProps.component_type || (prevProps.componentConfig || {}).componentname)) {
            this.loadComponentConfig();
        }
    }

    loadComponentConfig = () => {
        if (this.props.component_type) {
            this.loadComponentConfigRequest && this.loadComponentConfigRequest.abort();
            this.setState({componentConfig: null}, () => {
                this.loadComponentConfigRequest = getComponentConfig(this.props.component_type);
                this.loadComponentConfigRequest.then((componentConfig) => {
                    this.setState({componentConfig});
                });
            });
        }
    }

    render() {
        let url = null;
        let disabled = false;
        if (this.props.url) {
            url = this.props.url;
            disabled = this.props.disabled || disabled;
        } else {
            if (this.props.component_type && !this.state.componentConfig) {
                disabled = true;
            } else {
                const idfield = (this.props.component_type && this.state.componentConfig.idfield) || this.props.componentConfig.idfield;
                if (this.props.url) {
                    url = this.props.url;
                } else {
                    url = UrlGenerator();
                    delete url.fragment;
                    url.query = {
                        option: (this.props.component_type || this.props.componentConfig.componentname),
                        [idfield]: (this.props.component_id || this.props.values[idfield]),
                        resptype: this.props.type || "pdf"
                    };
                    url = url.toString();
                }
                disabled = !(this.props.component_id || this.props.values[idfield]) || this.props.disabled;
            }
        }

        return (
            <Button
                tag="a"
                href={url}
                target="_blank"
                disabled={disabled}
                block={this.props.block}
                size={this.props.size}
                color={this.props.color || "default"}
                icon={this.props.icon || {lib: "fa", name: "print"}}
                className={classNames(this.props.className)}
            >
                {this.props.children || "Nyomtatás"}
            </Button>
        );
    }
}